

export function initializeAccordion() {
    if($('.vs-accordion').length == 0) {
        return;
    }
    $('.vs-accordion .vs-accordion-item .vs-accordion-header').click(function() {
        if($(this).parent().siblings(".vs-accordion-item--open").length) {
            $(this).parent().siblings(".vs-accordion-item--open").children()[1].style.maxHeight = null;
            $(this).parent().siblings(".vs-accordion-item--open").children()[1].style.marginTop = '0';
            $(this).parent().siblings(".vs-accordion-item--open").removeClass("vs-accordion-item--open");
        }
        if($(this).parent().hasClass('vs-accordion-item--open')) {
            $(this).parent().removeClass('vs-accordion-item--open');
            $(this).parent().children()[1].style.maxHeight = null;
            //$(this).parent().children()[1].style.marginTop = '0';
        } else {
            $(this).parent().addClass('vs-accordion-item--open');
            $(this).parent().children()[1].style.maxHeight = $(this).parent().children()[1].scrollHeight + 'px';
            //$(this).parent().children()[1].style.marginTop = '20px';
        } 
    }); 
}

